<div class="d-flex flex-column">
  <div class="btn-group filters">
    <div ngbDropdown class="btn-group" *ngIf="dateTypes.length > 0">
      <button ngbDropdownToggle class="btn btn-sm btn-outline-primary" [disabled]="timedTaskes !== 'All'">
        {{'Range' | translate}}: {{dateFilter.selected_type | translate}}
      </button>
      <div ngbDropdownMenu>
        <button class="dropdown-item" *ngFor="let type of dateTypes"
                (click)="dateFilter.selected_type = type; timeTravels('');">{{type | translate}}
        </button>
      </div>
    </div>
    <div ngbDropdown class="btn-group" *ngIf="vivoTasks.length > 0">
      <button ngbDropdownToggle class="btn btn-sm btn-outline-primary">
        {{'Tasktypes' | translate}}: {{selectedTask.type}}
      </button>
      <div ngbDropdownMenu class="results" style="max-height: 20em; overflow-y: auto;">
        <button class="dropdown-item" (click)="selectedTask.type = 'All'; selectedTask.template_id = ''; vivoTask()">
          {{'All' | translate}}
        </button>
        <button class="dropdown-item" *ngFor="let single of vivoTasks"
                (click)="selectedTask.type = single.name; selectedTask.template_id = single.value; vivoTask()">
          {{single.name | translate}}
        </button>
      </div>
    </div>
    <div ngbDropdown class="btn-group">
      <button ngbDropdownToggle class="btn btn-sm btn-outline-primary" [disabled]="dateFilter.selected_type !== 'All'">
        {{'Duedate' | translate}}: {{timedTaskes  | translate}}
      </button>
      <div ngbDropdownMenu class="results" style="max-height: 20em; overflow-y: auto;">
        <button class="dropdown-item" (click)="dueDate('All'); timedTaskes = 'All'">
          {{'All' | translate}}
        </button>
        <button class="dropdown-item" (click)="dueDate('Late'); timedTaskes = 'Late'">
          {{'Late' | translate}}
        </button>
        <button class="dropdown-item" (click)="dueDate('Before'); timedTaskes = 'Coming'">
          {{'Coming' | translate}}
        </button>
      </div>
    </div>
  </div>
  <div class="arrow-buttons" *ngIf="dateFilter.selected_type !== 'All'"  style="width: 100%;">
    <div class="date-button">
      <a class="link" style="margin: auto;" (click)="timeTravels('previous')">
        <svg class="svg-inline--fa fa-w-20">
          <use xlink:href="#left"></use>
        </svg>
      </a>
    </div>
    <div class="date-field">
      <span>{{startDate | date: 'dd.MM.yyyy'}} - {{endDate |  date: 'dd.MM.yyyy'}}</span>
    </div>
    <div class="date-button">
      <a class="link" style="margin: auto;" (click)="timeTravels('next')">
        <svg class="svg-inline--fa fa-w-20">
          <use xlink:href="#right"></use>
        </svg>
      </a>
    </div>
  </div>
</div>

<i class="fas fa-arrow-left" data-fa-symbol="left"></i>
<i class="fas fa-arrow-right" data-fa-symbol="right"></i>
